import React from 'react';
import { useParams } from "react-router-dom";
import BlogArticleContentSection from "../sections/blogArticle/content/BlogArticleContentSection";
import RelatedArticlesSection from "../sections/blogArticle/relatedArticles/RelatedArticlesSection";

const BlogArticlePage = () => {
    const { handle } = useParams<{ handle: string }>();

    if (!handle) {
        return null;
    }

    return (
        <>
            <BlogArticleContentSection handle={handle} />
            <RelatedArticlesSection handle={handle} />
        </>
    );
};

export default BlogArticlePage;
